module.exports = "/images/id-step3.png?b655d4073ce43fe66d83373d8ded68d1";